export default {
  TitleForm: {
    Title: "Danh sách giao dịch thanh toán",
  },
  Brand: {
    STT: "STT",
    Customer: "Khách hàng",
    BillCode: "Mã đơn hàng",
    Money: "Số tiền",
    PaymentDate: "Thời gian thanh toán",
    Status: "Trạng thái",
  },
};
